import React, { useState, useEffect, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Search, Visibility } from '@material-ui/icons';

//tabla y card components
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import moment from 'moment';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy } from 'services/WService.js';

//compommnent
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import Filter from 'components/Tvendo/Common/FilterCustom';
import ModalGps from '../Modal/Modal';
import { currency } from 'hooks/Pipe';
import GridContainer from 'components/Grid/GridContainer';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import { wsGetAll } from 'services/WService';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import { Checkbox, FormControlLabel } from '@material-ui/core';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerCard: {
    fontSize: '.9em',
    '& .totals': {
      marginLeft: '20px',
      fontWeight: 'bold',
      color: 'black',
    },
  },
};
const useStyles = makeStyles(styles);

const dailyColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Fecha', accessor: 'periodDate', width: 100 },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'Cód. Proveedor', accessor: 'CardCode', width: 150 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Marca', accessor: 'mark', width: 150 },
  { Header: 'Mesa', accessor: 'bureau', width: 150 },
  { Header: 'Zona', accessor: 'zone', width: 100 },
  { Header: 'Clientes con ventas', accessor: 'selled_customers', width: 150 },
  // { Header: 'Clientes', accessor: 'visited_customers', width: 100 },
  { Header: 'Cuota', accessor: 'quota', width: 100, filterKey: 'without_igv' },
  { Header: 'Venta', accessor: 'progress', width: 100, filterKey: 'without_igv' },
  { Header: '%Avance', accessor: 'progress_percentage', width: 100, filterKey: 'without_igv' },

  { Header: 'Cuota IGV', accessor: 'quota_igv', width: 100, filterKey: 'with_igv' },
  { Header: 'Venta IGV', accessor: 'progress_igv', width: 100, filterKey: 'with_igv' },
  { Header: '%Avance IGV', accessor: 'progress_percentage_igv', width: 100, filterKey: 'with_igv' },

  { Header: '', accessor: 'actions', excelEnabled: false, width: 10 },
];

const periodColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Periodo', accessor: 'periodDate', width: 100 },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'Cód. Proveedor', accessor: 'CardCode', width: 150 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Marca', accessor: 'mark', width: 150 },
  { Header: 'Mesa', accessor: 'bureau', width: 150 },
  { Header: 'Zona', accessor: 'zone', width: 100 },
  { Header: 'Clientes con ventas', accessor: 'selled_customers', width: 150 },
  // { Header: 'Clientes', accessor: 'visited_customers', width: 100 },
  { Header: 'Cuota', accessor: 'quota', width: 100, filterKey: 'without_igv' },
  { Header: 'Venta', accessor: 'progress', width: 100, filterKey: 'without_igv' },
  { Header: '%Avance', accessor: 'progress_percentage', width: 100, filterKey: 'without_igv' },

  { Header: 'Cuota IGV', accessor: 'quota_igv', width: 100, filterKey: 'with_igv' },
  { Header: 'Venta IGV', accessor: 'progress_igv', width: 100, filterKey: 'with_igv' },
  { Header: '%Avance IGV', accessor: 'progress_percentage_igv', width: 100, filterKey: 'with_igv' },

  { Header: '', accessor: 'actions', excelEnabled: false, width: 10 },
];

export default WithApp(function MarkTracing(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [quotaMarks, setQuotaMarks] = useState([]);
  const [quotaMark, setQuotaMark] = useState({});
  const [checked, setChecked] = useState(false);
  const [valueSearch, setValueSearch] = useState({});
  const [processing, setProcessing] = useState(false);
  const [igvFilterKey, setIgvFilterKey] = useState('with_igv');

  const columns = useMemo(() => {
    let columns = checked ? periodColumns : dailyColumns;
    columns = columns.filter((column) => {
      if (column.filterKey === undefined) return true;
      return column.filterKey === igvFilterKey;
    });
    return columns;
  }, [checked, igvFilterKey]);

  // Mesas
  const [bureaus, setBureaus] = useState([]);
  const filteredBureaus = useMemo(() => {
    if (valueSearch.base_zone_id === undefined) return bureaus;
    return bureaus.filter(bureau => parseInt(bureau.base_zone_id) === valueSearch.base_zone_id);
  }, [bureaus, valueSearch.base_zone_id]);
  const [selectedBureaus, setSelectedBureaus] = useState([]);
  useEffect(() => {
    setSelectedBureaus([]);
  }, [valueSearch.base_zone_id]);
  // Canales
  const [canals, setCanals] = useState([]);
  const [selectedCanals, setSelectedCanals] = useState([]);

  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState();
  async function listProviders() {
    setDataLoading(true);
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    setDataLoading(false);
    if (response.success) setProviders(response.data);
  }

  const [marks, setMarks] = useState(undefined);
  const [selectedMark, setSelectedMark] = useState(undefined);
  const [products, setProducts] = useState(undefined);
  const [selectedProduct, setSelectedProduct] = useState(undefined);
  async function listMarks(bpId) {
    setDataLoading(true);
    setSelectedMark(undefined);
    setMarks([]);
    let response = await wsGetAll(`logi/mark?business_partners[]=${bpId}`);
    setDataLoading(false);
    if (response.success) setMarks(response.data);
  }

  async function listProducts(bpId, markId) {
    setDataLoading(true);
    setSelectedProduct(undefined);
    setProducts([]);
    let response = await wsGetAll(`logi/product?business_partners=${bpId}&logi_mark_id=${markId}`);
    setDataLoading(false);
    if (response.success) setProducts(response.data);
  }

  useEffect(() => {
    if (selectedProvider === undefined) {
      setSelectedMark(undefined);
      setMarks(undefined);
      return;
    }
    listMarks(selectedProvider.id);
  }, [selectedProvider]);

  useEffect(() => {
    if (selectedProvider === undefined || selectedMark === undefined) {
      setSelectedProduct(undefined);
      setProducts(undefined);
      return;
    }
    listProducts(selectedProvider.id, selectedMark.id);
  }, [selectedMark]);

  async function listQuotaMark(search) {
    checked ? (search.type = 'P') : (search.type = 'D');
    let date = search.date;
    if (search.type === 'P') {
      date = moment(search.date).format('YYYY-MM');
    } else {
      date = moment(search.date).format('YYYY-MM-DD');
    }

    let data = { ...search, date };
    if (selectedBureaus.length > 0) {
      data.bureaus = selectedBureaus.map((bureau) => bureau.id);
    }
    if (selectedCanals.length > 0) {
      data.canals = selectedCanals.map((canal) => canal.id);
    }
    if (selectedProvider !== undefined) {
      data.base_business_partner_id = selectedProvider.id;
    }
    if (selectedMark !== undefined) {
      data.logi_mark_id = selectedMark.id;
    }
    if (selectedProduct !== undefined) {
      data.logi_product_id = selectedProduct.id;
    }
    setDataLoading(true);
    setProcessing(true);
    let response = await wsFindBy('base/quota/mark', data);
    setProcessing(false);
    setDataLoading(false);
    if (response.success) {
      setQuotaMarks(response.data);
      // let quota = 0;
      // let sales = 0;
      // let progress = 0;
      // for (let i = 0; i < response.data.length; i++) {
      //   quota += parseFloat(response.data[i].quota || 0);
      //   sales += parseFloat(response.data[i].progress || 0);
      //   progress += parseFloat(response.data[i].progress_percentage || 0);
      // }
      // setTotals({
      //   quota: parseFloat(quota || 0).toFixed(2),
      //   sales: parseFloat(sales || 0).toFixed(2),
      //   progress: parseFloat(parseFloat(progress) / response.data.length || 0).toFixed(2),
      // });
    }
  }

  const totals = useMemo(() => {
    let totals = quotaMarks.reduce(
      (carry, quota) => {
        carry.quota += parseFloat(
          (igvFilterKey === 'without_igv' ? quota.quota : quota.quota_igv) || 0,
        );
        carry.sales += parseFloat(
          (igvFilterKey === 'without_igv' ? quota.progress : quota.progress_igv) || 0,
        );
        return carry;
      },
      {
        quota: 0,
        sales: 0,
      },
    );

    return {
      quota: parseFloat(totals.quota || 0).toFixed(2),
      sales: parseFloat(totals.sales || 0).toFixed(2),
      progress: parseFloat((totals.sales / totals.quota) * 100 || 0).toFixed(2),
    };
  }, [quotaMarks, igvFilterKey]);

  async function listBureaus() {
    setDataLoading(true);
    let res = await wsGetAll('base/bureau');
    setDataLoading(false);
    if (res.success) setBureaus(res.data);
  }

  async function listCanals() {
    setDataLoading(true);
    let res = await wsGetAll('base/canal');
    setDataLoading(false);
    if (res.success) {
      setCanals(res.data)
      setSelectedCanals(res.data);
    };
  }

  useEffect(() => {
    listBureaus();
    listCanals();
    listProviders();
  }, []);

  return (
    <>
      <Toasty action={notify} />
      <ModalGps
        nameList="mark"
        open={open}
        setOpen={setOpen}
        dataList={quotaMark}
        dateFilter={valueSearch.date}
        showNotify={showNotify}
      />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <div className={classes.cardIconTitle}>
            Listado de cuotas por marca
            {dataLoading && <LoadingSpinner />}
            <div className={classes.headerCard}>
              <span className="totals">Avance: {totals.progress}%</span>
              <span className="totals">Venta: {currency(totals.sales)}</span>
              <span className="totals">Cuota: {currency(totals.quota)}</span>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <GridContainer>
            {/* Filtros normales */}
            <GridItem xs={12}>
              <Filter
                getFilter={setValueSearch}
                date
                dateType={checked ? 'month' : 'date'}
                zone
                customControl={
                  <>
                    <GridItem xs={12} md={4} lg={3} xl={2}>
                      <SelectAutoComplete
                        label="Proveedor"
                        textField="CardName"
                        options={providers}
                        disabled={processing}
                        selectedOption={selectedProvider}
                        setSelectedOption={setSelectedProvider}
                      />
                    </GridItem>
                    <GridItem xs={12} md={4} lg={3} xl={2}>
                      <SelectAutoComplete
                        label="Marca"
                        textField="description"
                        disabled={processing || marks === undefined}
                        options={marks || []}
                        selectedOption={selectedMark}
                        setSelectedOption={setSelectedMark}
                      />
                    </GridItem>
                    <GridItem xs={12} md={4} lg={3} xl={2}>
                      <SelectAutoComplete
                        label="Producto"
                        textField="ItemName"
                        disabled={processing || marks === undefined || selectedMark === undefined}
                        options={products || []}
                        selectedOption={selectedProduct}
                        setSelectedOption={setSelectedProduct}
                      />
                    </GridItem>
                  </>
                }
              >
                <>
                  <GridItem
                    xs={12}
                    md={1}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      size="sm"
                      color={
                        checked
                          ? props.themeContext.buttonColor
                          : props.themeContext.buttonColorWarning
                      }
                      onClick={() => setChecked(!checked)}
                    >
                      {checked ? 'Periodo' : 'Día'}
                    </Button>
                    <Button
                      justIcon
                      round
                      color="success"
                      disabled={processing}
                      onClick={() => {
                        if (Object.keys(valueSearch).length > 0) listQuotaMark(valueSearch);
                      }}
                    >
                      <Search />
                    </Button>
                  </GridItem>
                </>
              </Filter>
            </GridItem>
            {/* Filtros multiples */}
            <GridItem xs={12} sm={6} md={3}>
              <MultiComplete
                label="Mesa"
                selectAll
                limitTags={1}
                textField="description"
                options={filteredBureaus}
                disabled={processing}
                selected={selectedBureaus}
                setSelected={setSelectedBureaus}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <MultiComplete
                label="Canal"
                selectAll
                limitTags={2}
                textField="description"
                options={canals}
                disabled={processing}
                selected={selectedCanals}
                setSelected={setSelectedCanals}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <FormControlLabel
                label="Ver con igv"
                control={
                  <Checkbox
                    margin="normal"
                    label="Ver con igv"
                    checked={igvFilterKey === 'with_igv'}
                    onChange={(_) => {
                      setIgvFilterKey((key) => {
                        if (key === 'with_igv') return 'without_igv';
                        return 'with_igv';
                      });
                    }}
                  />
                }
              />
            </GridItem>
          </GridContainer>
          <ReactTable
            excelName="Seguimiento-de-marca"
            formatDate="DD-MM-YYYY"
            defaultWidth={1500}
            columns={columns}
            data={quotaMarks.map((qMark, i) => {
              let igvData;
              if (igvFilterKey === 'without_igv') {
                igvData = {
                  quota: qMark.quota !== null ? currency(qMark.quota) : 'No hay cuota',
                  progress: qMark.progress,
                  progress_percentage: qMark.progress_percentage,
                };
              } else {
                igvData = {
                  quota_igv: qMark.quota_igv !== null ? currency(qMark.quota_igv) : 'No hay cuota',
                  progress_igv: qMark.progress_igv,
                  progress_percentage_igv: qMark.progress_percentage_igv,
                };
              }
              return {
                num: !checked ? (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_QUOTA_SHOW}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColor}
                        onClick={() => {
                          setOpen(true);
                          setQuotaMark(qMark);
                        }}
                      >
                        <Visibility />
                      </Button>
                    </AllowedGuard>
                  </div>
                ) : (
                  i + 1
                ),
                periodDate: qMark.date,
                SlpName: qMark.SlpName,
                CardCode: qMark.CardCode,
                CardName: qMark.CardName,
                mark: qMark.logi_mark_description,
                bureau: qMark.base_bureau_description,
                zone: qMark.base_zone_description,
                // visited_customers: qMark.visited_customers,
                selled_customers: qMark.selled_customers,
                // Data quota, progress, progress_percentage
                ...igvData,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
